"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
var _conditions = require("../../conditions");
class ConditionVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", ConditionVariable.settings);
    (0, _defineProperty2.default)(this, "type", "condition");
    (0, _defineProperty2.default)(this, "label", "Condition");
    (0, _defineProperty2.default)(this, "description", "Compares values and turns that into a true/false variable.");
  }
  dependencies(params, resolver) {
    return (0, _conditions.resolveConditions)(params.conditions, resolver);
  }
  value(deps, batcher) {
    if (!deps || deps.length === 0) {
      return null;
    }
    return (0, _conditions.testConditions)(deps);
  }
}
exports.ConditionVariable = ConditionVariable;
(0, _defineProperty2.default)(ConditionVariable, "settings", {
  conditions: {
    type: "conditions",
    title: "Conditions",
    description: "Conditions to evaluate for comparison."
  }
});
//# sourceMappingURL=ConditionVariable.js.map